<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'
import {
  getFirestore,
  collection,
  addDoc,
  serverTimestamp,
  updateDoc,
  doc,
} from 'firebase/firestore/lite'
import { firebase } from '../../../../../firebase-int'
import CryptoJS from 'crypto-js'
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
  uploadBytes,
} from 'firebase/storage'

const firestore = getFirestore(firebase)
const storage = getStorage(firebase)
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from 'vuelidate/lib/validators'

const mustHaveTags = (value) => value.length > 0

export default {
  page: {
    title: 'Add Content',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, Multiselect },
  data() {
    return {
      dismissSecs: 2,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      alertMessage: '',
      successStatus: true,
      processingData: false,
      isUploading: false,
      totalSize: 0,
      currentSize: 0,

      pvtData: '',
      secret: '123#$%',
      encData: '',

      newTag: 'starting text',
      tags: [],

      badFileSelected: false,
      badFileSelectedMessage: '',

      title: 'Add Content',
      items: [
        {
          text: 'Gebi',
          href: '/',
        },
        {
          text: 'Content',
          href: '/content-union',
        },
        {
          text: 'Add New',
          active: true,
        },
      ],
      industryValue: null,
      file: null,
      fileToBeWritten: '',
      fileName: '',
      form: {
        title: this.$store.state.auth.dummyTitle,
        description: this.$store.state.auth.dummyDescription,
        contentLink: this.$store.state.auth.dummyContentLink,
        topic: this.$store.state.auth.dummyTopic,
      },
      submit: false,
      submitted: false,
      formsubmit: false,
      typesubmit: false,

      calendarConfig: {
        wrap: true,
        dateFormat: 'd/m/Y',
      },
    }
  },
  validations: {
    form: {
      title: { required, minLength: minLength(2) },
      topic: { required, minLength: minLength(2) },
      description: { required, minLength: minLength(5) },
      contentLink: { required, url, minLength: minLength(5) },
    },
    fileName: { required },
    tags: { mustHaveTags },
  },
  methods: {
    resetInputValue() {
      this.newTag = ''
    },
    setTag(text) {
      this.newTag = text
    },
    /**
     * Basic Form submit
     */
    removeItem(item) {
      if (!this.isUploading) {
        this.file = null
        this.fileToBeWritten = ''
        this.fileName = ''
      }
      //this.files.splice(this.files.indexOf(item), 1);
    },
    async previewFiles(event) {
      if (event.target.value) {
        this.badFileSelected = false
        // console.log(
        //   '>>>>>>>>>>>> File Size: ' +
        //     event.target.files[0]['size'] +
        //     ' | ' +
        //     event.target.files.length
        // )
        this.file = null

        if (
          event.target.files[0]['type'] === 'image/jpeg' ||
          event.target.files[0]['type'] === 'image/png' ||
          event.target.files[0]['type'] === 'image/jpg'
        ) {
          if (event.target.files[0]['size'] > 500000) {
            // console.log(
            //   '>>>>>>>>>>>>>> got in here: this.badFileSelected: ' +
            //     this.badFileSelected
            // )
            this.badFileSelected = true
            this.badFileSelectedMessage = this.$i18n.t(
              'page.content.fileSizeWarning'
            )
            setTimeout(() => {
              this.badFileSelected = false
            }, 2000)

            event.target.value = ''
          } else {
            this.file = event.target.files[0]
            console.log(this.file.name)
            this.fileName = this.file.name
            //console.log('>>>>>>>>>>> Proper file name')
            event.target.value = ''
          }
        } else {
          //console.log('>>>>>>>>>>> Noot!')
          this.badFileSelected = true
          this.badFileSelectedMessage = this.$i18n.t(
            'page.content.fileFormatWarning'
          )
          setTimeout(() => {
            this.badFileSelected = false
          }, 2000)
          event.target.value = ''
        }
        // if (event.target.files[0]['size'] > 500000) {
        //       console.log('>>>>>>>>>>>>>> got in here: this.badFileSelected: '+this.badFileSelected)
        //       this.badFileSelectedMessage =
        //         'File size should be not bigger than 500KB'
        //       this.badFileSelected = true
        //       event.target.value = ''
        //     }
        //event.target.value = ''
      }
    },
    async handleSubmit(e) {
      const secondsSinceEpoch = Math.round(Date.now() / 1000)
      this.submitted = true
      // stop here if form is invalid
      this.$v.$touch()
      //console.log('>>>>>>>>>>>> tags: '+this.tags);
      //console.log('>>>>>>>>>>>> file: '+this.fileName);
      //console.log('>>>>>>>>>>>> this.$v.form.$pending: '+this.$v.form.$pending);
      //console.log('>>>>>>>>>>>> this.$v.form.$error: '+this.$v.form.$error);
      //console.log('>>>>>>>>>>>> this.$v.$error: '+this.$v.$error);
      if (this.$v.form.$pending || this.$v.form.$error || this.$v.$error) return
      //await this.uploadFiles()
      await this.uploadFile(
        this.file,
        'Debo_' +
          this.$store.state.auth.currentUser.id +
          '_' +
          secondsSinceEpoch +
          '_' +
          this.file.name
      )
    },

    // async uploadFiles()
    // {
    //   //disable button
    //   this.processingData=true;
    //   const secondsSinceEpoch = Math.round(Date.now() / 1000)
    //   this.filesToBeWritten=[]
    //   this.isUploading=true;
    //   for (const file of this.files) {
    //     await this.uploadFile(file, 'Debo_'+this.$store.state.auth.currentUser.id+'_'+secondsSinceEpoch+'_'+file.name)
    //   }
    //   this.isUploading=false;
    //   //console.log('>>>>>>>>>>>>. this is end of for loop');
    //   //console.log('>>>>>>>>>>>> links size: '+this.filesToBeWritten.length);
    //   //for(const f of this.filesToBeWritten)
    //     //console.log('>>>>>>>>>>>> File: '+f);
    //   this.addTraining()
    // },

    getContentOrganizer() {
      var userAccessLevel = this.$store.state.auth.currentUser.accessLevel
      if (userAccessLevel == 'Administrator' || userAccessLevel == 'Editor')
        return 'CETU'
      else if (userAccessLevel == 'Union Administrator')
        return this.$store.state.auth.currentUser.adminUnion
      else if (userAccessLevel == 'Federation Administrator')
        return this.$store.state.auth.currentUser.adminFederation
      else return null
    },

    getContentOrganingEntity() {
      var userAccessLevel = this.$store.state.auth.currentUser.accessLevel
      if (userAccessLevel == 'Administrator' || userAccessLevel == 'Editor')
        return 'CETU'
      else if (userAccessLevel == 'Union Administrator') return 'Union'
      else if (userAccessLevel == 'Federation Administrator')
        return 'Federation'
      else return null
    },

    async addContent() {
      this.processingData = true
      try {
        const docRef = await addDoc(collection(firestore, 'content'), {
          title: this.form.title,
          topic: this.form.topic,
          description: this.form.description,
          contentLink: this.form.contentLink,
          created: serverTimestamp(),
          updated: serverTimestamp(),
          createdBy: this.$store.state.auth.currentUser.id,
          updatedBy: this.$store.state.auth.currentUser.id,
          coverImage: this.fileToBeWritten,
          fileName: this.fileName,
          tags: this.tags,
          organizedBy: this.getContentOrganizer(),
          organizingEntity: this.getContentOrganingEntity(),
        })
        //this.makeToast(false, "Document written with ID: ", docRef.id);
        this.successStatus = true
        this.dismissSecs = 2
        this.alertMessage = this.$i18n.t('page.content.contentAddedMessage') + docRef.id
        this.showAlert()
        console.log('Document written with ID: ', docRef.id)
        await this.addToLog(
          'content added',
          this.$store.state.auth.currentUser.id,
          docRef.id
        )
        //this.clearFields();
        setTimeout(() => {
          this.$router.push({ name: 'Union Content' })
        }, 2000)
      } catch (e) {
        console.error('Error adding document: ', e)
        this.successStatus = false
        this.dismissSecs = 4
        this.alertMessage = this.$i18n.t('page.content.unableToadd')
        this.showAlert()
        this.processingData = false
      }
      //this.processingData=false;
    },
    async uploadFile(file, fileName) {
      //const storage = getStorage();
      this.processingData = true
      this.isUploading = true
      const storageRef = ref(storage, 'contents/' + fileName)
      await uploadBytes(storageRef, file).then(async (snapshot) => {
        //this.currentSize=(snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        //this.totalSize=100;
        //console.log('File uploaded!')
        await getDownloadURL(snapshot.ref).then((downloadURL) => {
          //this.filesToBeWritten.push(downloadURL);
          this.fileToBeWritten = downloadURL
          //console.log('File available at', downloadURL)
          this.isUploading = false
          this.addContent()
        })
      })
    },
    clearFields() {
      this.form.title = 'Training title'
      this.form.description = 'Description goes here'
      this.files = []
      this.fileNames = []
      this.filesToBeWritten = []
      //console.log('Data cleared!')
    },

    // alert related methods
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },

    // encryption related methods
    encryptData(passwordData) {
      // return CryptoJS.AES.encrypt(JSON.stringify({ passwordData }), this.secret).toString();
      return CryptoJS.AES.encrypt(passwordData, this.secret).toString()
    },

    gotoContents() {
      this.$router.push({ name: 'Union Content', params: { userId: '123' } })
    },
  },
  mounted() {},
}
</script>

<template>
  <Layout>
    <PageHeader :title="$t('page.content.titleAdd')" />
    <div class="row">
      <div class="col-lg-12">
        <b-alert
          v-if="successStatus"
          :show="dismissCountDown"
          dismissible
          fade
          variant="success"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
        >
          <p>{{ alertMessage }}</p>
        </b-alert>
        <b-alert
          v-else
          :show="dismissCountDown"
          dismissible
          fade
          variant="danger"
          @dismissed="dismissCountDown = 0"
          @dismiss-count-down="countDownChanged"
        >
          <p>{{ alertMessage }}</p>
        </b-alert>

        <b-alert v-if="isUploading" show fade variant="success">
          <p>{{ $t('page.content.uploadingFilesAlert') }}</p>
          <!--b-progress
            variant="warning"
            :max="totalSize"
            :value="currentSize"
            height="4px"
          ></b-progress-->
        </b-alert>

        <b-alert :show="badFileSelected" variant="danger" fade>
          <p>{{ badFileSelectedMessage }}</p>
        </b-alert>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="header-title mt-0 mb-1">{{
              $t('page.content.contentInfo')
            }}</h4>
            <p class="sub-header">{{ $t('page.content.enterContentInfo') }}</p>
            <form @submit.prevent="handleSubmit">
              <div class="form-group">
                <label for="title" :class="this.getStyle()">
                  {{ $t('page.content.labelTitle') }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="title"
                  v-model="form.title"
                  name="title"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.title.$error }"
                  type="text"
                />
                <div
                  v-if="submitted && $v.form.title.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.title.required">{{
                    $t('page.content.errorValueRequired')
                  }}</span>
                  <span v-if="!$v.form.title.minLength">{{
                    $t('page.content.mustBeTwoLong')
                  }}</span>
                </div>
              </div>
              <div class="form-group">
                <label :class="this.getStyle()">
                  {{ $t('page.content.labelDescription') }}
                  <span class="text-danger">*</span>
                </label>
                <textarea
                  v-model="form.description"
                  type="text"
                  rows="5"
                  name="description"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.description.$error,
                  }"
                />
                <div
                  v-if="submitted && $v.form.description.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.description.required">{{
                    $t('page.content.errorValueRequired')
                  }}</span>
                  <span v-if="!$v.form.description.minLength">{{
                    $t('page.content.bodyWarning')
                  }}</span>
                </div>
              </div>

              <div class="form-group">
                <label for="topic" :class="this.getStyle()">
                  {{ $t('page.content.labelTopic') }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="topic"
                  v-model="form.topic"
                  name="topic"
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.form.topic.$error }"
                  type="text"
                />
                <div
                  v-if="submitted && $v.form.topic.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.topic.required">{{
                    $t('page.content.errorValueRequired')
                  }}</span>
                  <span v-if="!$v.form.topic.minLength">{{
                    $t('page.content.mustBeTopicLong')
                  }}</span>
                </div>
              </div>

              <div class="form-group">
                <label for="contentLink" :class="this.getStyle()">
                  {{ $t('page.content.labelContentLink') }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="contentLink"
                  v-model="form.contentLink"
                  name="contentLink"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.contentLink.$error,
                  }"
                  type="text"
                />
                <div
                  v-if="submitted && $v.form.contentLink.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.contentLink.required">{{
                    $t('page.content.errorValueRequired')
                  }}</span>
                  <span v-if="!$v.form.contentLink.url">{{
                    $t('page.content.enterValidLink')
                  }}</span>
                </div>
              </div>

              <div class="form-group">
                <label for="tags-separators" :class="this.getStyle()">
                  {{ $t('page.content.enterTags') }}
                  <span class="text-danger">*</span>
                </label>
                <b-form-tags
                  input-id="tags-separators"
                  v-model="tags"
                  separator=" "
                  remove-on-delete
                  no-add-on-enter
                  tag-variant="primary"
                  :class="{ 'is-invalid': submitted && $v.tags.$error }"
                ></b-form-tags>
                <p class="mt-2">{{ $t('page.content.tags') }}: {{ tags }}</p>
                <div
                  v-if="submitted && $v.tags.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.tags.required">{{
                    $t('page.content.atLeastOneTag')
                  }}</span>
                </div>
              </div>

              <div class="form-group">
                <label :class="this.getStyle()">
                  {{ $t('page.content.attachImage') }}
                  <span class="text-danger">*</span>
                </label>
                <div>
                  <ul v-if="file" id="example-1">
                    <li style="margin: 10px 0">
                      <b-button
                        @click="removeItem()"
                        variant="outline-primary"
                        >{{ file.name }}</b-button
                      >
                    </li>
                  </ul>
                </div>
                <div>
                  <b-form-file
                    v-model="file"
                    :state="Boolean(file)"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    :disabled="isUploading || badFileSelected"
                    @change="previewFiles"
                    accept="image/*"
                  ></b-form-file>
                  <!--input
                    type="file"
                    @change="previewFiles"
                    :disabled="isUploading || badFileSelected"
                    accept="image/*"
                  /-->

                  <input
                    id="fileName"
                    v-model="fileName"
                    name="fileName"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.fileName.$error }"
                    type="hidden"
                  />
                  <div
                    v-if="submitted && $v.fileName.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.fileName.required">{{
                      $t('page.content.imageRequired')
                    }}</span>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <!--form @submit.prevent="handleSubmit">
                  <button v-if='!processingData' type="submit" class="btn btn-primary"
                    >Save</button>
                  <button v-else disabled  class="btn btn-primary"
                  >Save</button>
                  <a href="/member">
                  <button class="btn btn-secondary m-l-5 ml-1"
                    >Cancel</button></a>
            </form-->
            <form @submit.prevent="handleSubmit">
              <template>
                <b-button
                  :disabled="processingData"
                  type="submit"
                  variant="primary"
                  ><i class="uil uil-down-arrow mr-1"></i
                  >{{ $t('page.content.saveChanges') }}</b-button
                >
                <b-button
                  variant="light"
                  @click="gotoContents"
                  style="margin-left: 10px"
                  >{{ $t('page.content.close') }}</b-button
                >
              </template>
            </form>
          </div>
        </div>
        <!-- end card--->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style scoped>
.btn {
  font-size: 1rem;
}
.btnSmallAm {
  font-size: 0.875rem;
}
.btnSmallEn {
  font-size: 0.675rem;
}
.lighterTextAm {
  font-weight: 500 !important;
  font-size: 1rem !important;
}
.lighterTextEn {
  font-weight: 600 !important;
  font-size: 0.875rem !important;
}
.lighterTextSmallAm {
  font-weight: 500 !important;
  font-size: 0.875rem !important;
}
.lighterTextSmallEn {
  font-weight: 600 !important;
  font-size: 0.675rem !important;
}
</style>

